import { Option } from 'fp-ts/lib/Option';
import { AdministrationPrice } from './administration-price.type';
import { EstateId } from './estate-id.type';
import { Price } from './price.type';
import { UserId } from './user-id.type';

export class EstateApplicationInfo {
  constructor(
    public readonly estateId: EstateId,
    public readonly admonPrice: AdministrationPrice,
    public readonly rentalPrice: Price,
    public readonly broker: Option<UserId>
  ) {}
}
